import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AppTopBar } from "@/components/AppTopBar";

const canReceive = (role) => role === "OWNER" || role === "ADMIN_INVENTORY";

export default function ReceivingList() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [eligible, setEligible] = useState([]);
  const [receipts, setReceipts] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    Promise.all([api.get("/receipts/eligible-purchases"), api.get("/receipts")])
      .then(([e, r]) => { setEligible(e.data); setReceipts(r.data); })
      .catch((err) => { console.error(err); setError(formatApiErrorDetail(err.response?.data?.detail)); });
  }, []);

  if (user && !canReceive(user.role)) {
    return (<div className="app-shell"><AppTopBar active="receiving" /><main className="content"><div className="alert-error" data-testid="access-denied">Akses ditolak.</div></main></div>);
  }

  return (
    <div className="app-shell">
      <AppTopBar active="receiving" />
      <main className="content">
        {error && <div className="alert-error" data-testid="error-banner">{error}</div>}

        <section className="panel" data-testid="eligible-panel">
          <h2 className="panel-title">Purchase Punya Outstanding ({eligible.length})</h2>
          <div className="table-scroll">
            <table className="data-table" data-testid="eligible-table">
              <thead><tr><th>Purchase No</th><th>Tanggal</th><th>Status</th><th>SKU</th><th>Outstanding</th><th>Aksi</th></tr></thead>
              <tbody>
                {eligible.length === 0 && <tr><td colSpan={6} className="empty-cell">Tidak ada Purchase dengan outstanding.</td></tr>}
                {eligible.map((p) => (
                  <tr key={p.id} data-testid={`eligible-row-${p.purchase_no}`}>
                    <td className="mono">{p.purchase_no}</td>
                    <td>{p.purchase_date}</td>
                    <td><span className="status-pill on">{p.status}</span></td>
                    <td>{p.item_count}</td>
                    <td className="mono">{p.total_outstanding}</td>
                    <td><button className="btn-mini" onClick={() => navigate(`/receiving/new/${p.id}`)} data-testid={`receive-${p.purchase_no}`}>Terima Barang</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        <section className="panel" data-testid="receipts-panel">
          <h2 className="panel-title">Riwayat Penerimaan ({receipts.length})</h2>
          <div className="table-scroll">
            <table className="data-table" data-testid="receipts-table">
              <thead><tr><th>Receipt No</th><th>Purchase No</th><th>Status Purchase</th><th>Waktu</th><th>Aksi</th></tr></thead>
              <tbody>
                {receipts.length === 0 && <tr><td colSpan={5} className="empty-cell">Belum ada penerimaan.</td></tr>}
                {receipts.map((r) => (
                  <tr key={r.id} data-testid={`receipt-row-${r.receipt_no}`}>
                    <td className="mono">{r.receipt_no}</td>
                    <td className="mono">{r.purchase_no}</td>
                    <td><span className={`status-pill ${r.purchase_status === "RECEIVED" ? "on" : "off"}`}>{r.purchase_status}</span></td>
                    <td>{new Date(r.received_at).toLocaleString("id-ID")}</td>
                    <td><button className="btn-mini" onClick={() => navigate(`/receiving/${r.id}`)} data-testid={`receipt-detail-${r.receipt_no}`}>Detail</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      </main>
    </div>
  );
}
